module.exports = __webpack_public_path__ + "static/media/icons8-close-window.877f6e5a.svg";